import { CycleStatus } from "@/enums/Cycle/CycleStatus";

const variants = [
  "danger",
  "info",
  "success",
  "warning",
  "primary",
  "secondary",
];
var arr = Object.keys(CycleStatus);

export const getCycleStatus = (value) => {
  const index = arr.findIndex((e) => e === value); // 0
  if (index > -1) {
    const item = index % variants.length;
    return { key: value, variant: variants[item], name: CycleStatus[value] };
  }
  return { key: value, variant: "danger", name: CycleStatus[value] };
};
